<template>
	<gmap-map
		:options="options"
		:center="{ lat: location.lat, lng: location.lon }"
		:zoom="15"
		style="width: 100%; height: 400px"
	>
		<gmap-marker
			:position="{ lat: location.lat, lng: location.lon }"
			:clickable="true"
			:draggable="true"
		/>
	</gmap-map>
</template>

<script>
export default {
	props: {
		id: { type: Number, required: true }
	},
	data() {
		return {
			options: {
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: true,
				disableDefaultUi: false
			}
		};
	},
	created() {
		this.keyword = window.config.keyword;
	},
	mounted() {
		this.$store.dispatch('fetchLocations');
	},
	computed: {
		address() {
			return `${location.line1} ${location.line2} ${location.line3}, ${location.locality}, ${location.stateprovincecounty}, ${location.ziporpostcode}`;
		},
		location() {
			return this.$store.getters.getLocationForId(this.id);
		}
	}
};
</script>

<style></style>
